module.exports = __webpack_public_path__ + "img/Logistics-rafiki 1.4e74887e.svg";